export const getTabs = (name = "") => {
  return [
    { key: "trial", value: "Trial" },
    { key: "top-players", value: "Trial Top Players" },
  ];
};
